<template>
  <div class="py-0 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-7"></div>
          <div class="col-md-5">
            <div class="border-radius-lg pb-2" >
              <div class="d-flex align-items-center" style="font-size: 80%; justify-content: flex-end; width: 100%;">
                <span class="fw-bold me-2" style="color: #FFF">Filtrar por:</span>
                <vue-select
                  :options="periodos"
                  label="text"
                  v-model="selectedPeriodo"
                  :reduce="(option) => option.value"
                  style="width: 240px;"
                  id="periodoSelect"
                  class="periodoSelect"
                ></vue-select>
              </div>
            </div>
            <div class="col-md-12 bg-white border-radius-xl px-3 py-1 mb-2" v-show="selectedPeriodo === 'periodo'">
              <div class="row">
                <div class="col-md-5">
                <label for="example-text-input" class="form-control-label">Desde</label>
                <datepicker
                  v-model="fechaInicio"
                  v-bind="basicConfigDatePicker"
                  :max-date="fechaFin || null"
                  @update:modelValue="validarFiltros"
                />
                  <!-- :name="String(n)" -->
              </div>
              <div class="col-md-5">
                <label class="form-control-label">Hasta</label>
                <datepicker
                  v-model="fechaFin"
                  v-bind="basicConfigDatePicker"
                  :min-date="fechaInicio || null"
                  @update:modelValue="validarFiltros"
                />
                <div v-if="error" class="error-message-dashboard">
                  {{ error }}
                </div>
              </div>
              <div class="col-md-2">
                <button
                  class="btn btn-addiuva-dark"
                  style="margin-top: 32px;"
                  title="Generar"
                  v-if="!error"
                  @click="getAllData"
                >
                  <i class="fas fa-search"></i>
                </button>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.ventas.title"
              :titleColor="'text-addiuva-dark'"
              :value="stats.ventas.value"
              :percentage="stats.ventas.percentage"
              :iconClass="stats.ventas.iconClass"
              :iconBackground="stats.ventas.iconBackground"
              :detail="stats.ventas.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.cantidadProductos.title"
              :value="stats.cantidadProductos.value"
              :percentage="stats.cantidadProductos.percentage"
              :percentageColor="stats.cantidadProductos.percentageColor"
              :iconClass="stats.cantidadProductos.iconClass"
              :iconBackground="stats.cantidadProductos.iconBackground"
              :detail="stats.cantidadProductos.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.clients.title"
              :value="stats.clients.value"
              :percentage="stats.clients.percentage"
              :iconClass="stats.clients.iconClass"
              :iconBackground="stats.clients.iconBackground"
              :percentageColor="stats.clients.percentageColor"
              :detail="stats.clients.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.sales.title"
              :value="stats.sales.value"
              :valueColor="stats.sales.valueColor"
              :percentage="stats.sales.percentage"
              :percentageColor="stats.sales.percentageColor"
              :iconClass="stats.sales.iconClass"
              :iconBackground="stats.sales.iconBackground"
              :detail="stats.sales.detail"
              directionReverse
            ></card>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 px-3 py-1">
            <div class="bg-white border-radius-lg">
              <ChartTendencias
                :categories="chartTendenciasData.categories"
                :anulaciones="chartTendenciasData.anulaciones"
                :ventas="chartTendenciasData.ventas"
                title="Tendencias de ventas"
                subtitle="Ventas y Anulaciones"
              />
                <!-- class="border-radius-lg p-1" -->
            </div>
            <div class="bg-white border-radius-lg" style="margin-top: 12px;">
                <ChartAfiliados
                  :categories="chartAfiliadosData.afiliados"
                  :anulaciones="chartAfiliadosData.anulaciones"
                  :ventas="chartAfiliadosData.ventas"
                  title="Afiliados"
                  subtitle="Ventas y Anulaciones"
                />
                <div style="display: flex; justify-content: center; padding-bottom: 12px; font-size: 0.8em;">
                  <span style="margin-top: 8px;">Cantidad de Afiliados</span>
                  <vue-select
                    :options="[5, 10, 15]"
                    label="text"
                    v-model="cantidadAfiliados"
                    style="width: 100px; margin-left: 4px; margin-right: 4px;"
                  ></vue-select>
                </div>
              </div>
          </div>

          <div class="col-md-6 px-3 py-1">
            <div class="bg-white border-radius-lg">
              <ChartProductosPie
                :seriesData="chartProductosData"
                title="Productos"
                subtitle="Cantidad de Productos Vendidos"
              />
            </div>
          </div>

          <div class="col-md-12 px-3 py-2">
            <div class="bg-white border-radius-lg">
              <ChartProductosColumn
                :seriesData="chartProductosDetailsData"
                title="Detalle de Ventas por Producto"
                subtitle=""
              />
            </div>
          </div>
          <!--
          <div class="col-md-12 px-3 py-2">
            <div class="bg-white border-radius-lg" style="height: 100%;">
              <ChartAfiliados
                :categories="chartAfiliadosData.afiliados"
                :anulaciones="chartAfiliadosData.anulaciones"
                :ventas="chartAfiliadosData.ventas"
                title="Afiliados"
                subtitle="Ventas y Anulaciones"
              />
              <div style="display: flex; justify-content: center; padding-bottom: 12px; font-size: 0.8em;">
                <span style="margin-top: 8px;">Cantidad de Afiliados</span>
                <vue-select
                  :options="[5, 10, 15]"
                  label="text"
                  v-model="cantidadAfiliados"
                  style="width: 100px; margin-left: 4px; margin-right: 4px;"
                ></vue-select>
              </div>
            </div>
          </div> -->

        </div>
        <div class="row">
        </div>
        <!-- <div class="row">
          <div class="col-lg-12 bg-white border-radius-lg px-3 py-1 mb-4">
            <highcharts :options="chartOptions" ref="chart"></highcharts>
          </div>
        </div> -->
        <!-- <div class="row">
          <div class="col-lg-7 mb-lg">

            <div class="card z-index-2">
              <gradient-line-chart />
            </div>
          </div>
          <div class="col-lg-5">

          </div>
        </div> -->
        <!--
        <div class="row mt-4">
          <div class="col-lg-7 mb-lg-0 mb-4">
            <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Sales by Country</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table align-items-center">
                    <tbody>
                      <tr v-for="(sale, index) in sales" :key="index">
                        <td class="w-30">
                          <div class="px-2 py-1 d-flex align-items-center">
                            <div>
                              <img :src="sale.flag" alt="Country flag" />
                            </div>
                            <div class="ms-4">
                              <p class="mb-0 text-xs font-weight-bold">Country:</p>
                              <h6 class="mb-0 text-sm">{{ sale.country }}</h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Sales:</p>
                            <h6 class="mb-0 text-sm">{{ sale.sales }}</h6>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <p class="mb-0 text-xs font-weight-bold">Value:</p>
                            <h6 class="mb-0 text-sm">{{ sale.value }}</h6>
                          </div>
                        </td>
                        <td class="text-sm align-middle">
                          <div class="text-center col">
                            <p class="mb-0 text-xs font-weight-bold">Bounce:</p>
                            <h6 class="mb-0 text-sm">{{ sale.bounce }}</h6>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
          <div class="col-lg-5">
            <categories-card />
          </div>
        </div>
      -->
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
// import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
// import CategoriesCard from "./components/CategoriesCard.vue";
// import Highcharts from 'highcharts';
import * as Highcharts from "highcharts";
import "highcharts/modules/exporting";
import "highcharts/modules/offline-exporting";
import "highcharts/modules/export-data";
import "highcharts/modules/accessibility";
import "highcharts/modules/series-label";
import "highcharts/modules/drilldown";
import Datepicker from 'vuejs3-datepicker';
import axios from 'axios';
import authHeader from '../services/auth-header';
import VueSelect from "vue-select";
import ChartTendencias from "./components/ChartTendencias.vue";
import ChartAfiliados from "./components/ChartAfiliados.vue";
import ChartProductosPie from "./components/ChartProductosPie.vue";
import ChartProductosColumn from "./components/ChartProductosColumn.vue";
// import Highcharts from "highcharts";
// import exportingInit from "highcharts/modules/exporting";

// exportingInit(Highcharts);
import US from "@/assets/img/icons/flags/US.png";
import DE from "@/assets/img/icons/flags/DE.png";
import GB from "@/assets/img/icons/flags/GB.png";
import BR from "@/assets/img/icons/flags/BR.png";
Highcharts.setOptions({
  lang: {
    decimalPoint: '.',       // Separador decimal
    thousandsSep: '',       // Separador de miles
    numericSymbols: null,    // Evita usar k, M para miles/millones si causa problemas
    exportButtonTitle: "Guardar Gráfico",
    printChart: "Imprimir",
    downloadPNG: "Descargar como PNG",
    downloadJPEG: "Descargar como JPG",
    downloadPDF: "Descargar como PDF",
    downloadSVG: "Descargar como SVG",
    downloadCSV: "Descargar como CSV",
    downloadXLS: "Descargar como XLS",
    viewData: "Ver Tabla de Datos",
    hideData: "Ocultar Tabla de Datos",
    contextButtonTitle: "Opciones de Exportación",
    viewFullscreen: "Ver en Pantalla Completa",
    exitFullscreen: "Salir de Pantalla Completa",
    loading: "Cargando..."
    // ... otras opciones de 'lang' si las necesitas
    // consulta la documentación de Highcharts API para 'lang'
  },
  credits: {
    enabled: false, // Desactiva la marca de agua de Highcharts
  },
  chart: {
    backgroundColor: '#FFF', // Cambia el color de fondo del gráfico
  },
  exporting: {
    // Deshabilitar exportación SVG (usa PNG/JPEG)
    chartOptions: {
      plotOptions: {
        series: {
          animation: false
        }
      }
    },
    // Usar exportación client-side
    libURL: 'https://code.highcharts.com/12.2.0/lib/',
    fallbackToExportServer: false,
  },
  debug: {
    enabled: true
  }
});
export default {
  name: "dashboard",
  data() {
    // const vm = this;
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      selectedPeriodo: "semana",
      periodos: [
        { text: "Hoy", value: "hoy" },
        { text: "últimos 7 días", value: "semana" },
        { text: "Últimos 30 días", value: "mes" },
        { text: "Último Trimestre", value: "trimestre" },
        { text: "Periodo Personalizado", value: "periodo" },
      ],
      fechaInicio: new Date(),
      fechaFin: new Date(new Date().setDate(new Date().getDate() - 7)),
      stats: {
        ventas: {
          title: "Movimiento Económico",
          value: "0",
          percentage: "0",
          iconClass: "ni ni-money-coins",
          detail: "Anulaciones",
          iconBackground: "bg-gradient-primary",
        },
        cantidadProductos: {
          title: "Cantidad de Productos",
          value: "0",
          percentage: "0",
          percentageColor: "text-md",
          iconClass: "ni ni-box-2",
          iconBackground: "bg-gradient-danger",
          detail: "Unidades vendidas",
        },
        clients: {
          title: "Promedio Afiliados",
          value: "0",
          percentage: "Valor calculado según el top de Afiliados",
          iconClass: "ni ni-single-02",
          iconBackground: "bg-gradient-success",
          detail: "",
        },
        sales: {
          title: "Lider en ventas (Bs)",
          value: "...",
          valueColor: "text-xs",
          percentage: "",
          percentageColor: "text-xs",
          iconClass: "ni ni-cart",
          iconBackground: "bg-gradient-warning",
          detail: "/unidades",
        },
      },
      sales: {
        us: {
          country: "United States",
          sales: 2500,
          value: "$230,900",
          bounce: "29.9%",
          flag: US,
        },
        germany: {
          country: "Germany",
          sales: "3.900",
          value: "$440,000",
          bounce: "40.22%",
          flag: DE,
        },
        britain: {
          country: "Great Britain",
          sales: "1.400",
          value: "$190,700",
          bounce: "23.44%",
          flag: GB,
        },
        brasil: {
          country: "Brasil",
          sales: "562",
          value: "$143,960",
          bounce: "32.14%",
          flag: BR,
        },
      },
      chartOptions: {
        chart: {
          type: 'spline'
        },
        title: {
          text: 'Entire title'
        },
        series: [{
          data: [10, 0, 8, 2, 6, 4, 5, 5]
        }]
      },
      tendencias: [],
      chartTendenciasData: {
        categories: [],
        anulaciones: [],
        ventas: []
      },
      cantidadAfiliados: 5,
      chartAfiliadosData: {
        afiliados: [],
        anulaciones: [],
        ventas: []
      },
      chartProductosData: [],
      chartProductDetailsData: [],
    };
  },
  methods: {
    showMessage: function () {
      this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Su mensaje fue enviado exitosamente.', life: 3000 });
    },
    svgToBase64PNG: async function (svgString) {
      return new Promise((resolve, reject) => {
        // 1. Codificar la cadena SVG a UTF-8 y luego a Base64
        const utf8Svg = unescape(encodeURIComponent(svgString));
        const base64Svg = btoa(utf8Svg);

        // 2. Crear un elemento de imagen HTML
        const img = new Image();

        // 3. Establecer el origen de la imagen como un Data URI del SVG codificado
        img.src = `data:image/svg+xml;base64,${base64Svg}`;

        // 4. Esperar a que la imagen se cargue
        img.onload = () => {
          // 5. Crear un elemento canvas para dibujar la imagen
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");

          // 6. Dibujar la imagen en el canvas
          ctx.drawImage(img, 0, 0);

          // 7. Convertir el contenido del canvas a PNG y luego a Base64
          const pngBase64 = canvas.toDataURL("image/png");

          // 8. Resolver la promesa con el resultado en Base64
          resolve(pngBase64);
        };

        // 9. Manejar errores de carga de la imagen
        img.onerror = (error) => {
          reject(error);
        };
      });
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    getTendenciaVentas: function () {
      this.tendencias = [];
      let payload = {
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '2025-05-01',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '2025-05-08',
      }
      // Send Data by Axios
      let url = this.API_URL + "/dashboards/ventasanulaciones";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
          let data = response.data.data;
          data["fechas"] = Object.keys(data.ventas);
          this.tendencias = data;
          this.chartTendenciasData.anulaciones = Object.entries(this.tendencias?.anulaciones || {});
          this.chartTendenciasData.ventas = Object.entries(this.tendencias?.ventas || {});
          this.chartTendenciasData.categories = (Array.from(this.tendencias?.fechas || []));
          // this.chartTendenciasData.plotOptions.area.pointStart = this.tendencias?.fechas[0] || 0;
          // Sum ar los valores de ventas y anulaciones
          let totalVentas = Object.values(this.tendencias?.ventas || {}).reduce((a, b) => a + b, 0);
          let totalAnulaciones = Object.values(this.tendencias?.anulaciones || {}).reduce((a, b) => a + b, 0);
          // Actualizar los valores de las estadísticas
          this.stats.ventas.value = totalVentas.toLocaleString('es-BO', { style: 'currency', currency: 'BOB' });
          this.stats.ventas.percentage = totalAnulaciones.toLocaleString('es-BO', { style: 'currency', currency: 'BOB' });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getTopAfiliados: function () {
      let payload = {
        "cantidad": this.cantidadAfiliados,
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '2025-05-01',
        // "fecha_inicio": '2023-01-01',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '2025-05-08',
      }
      // Send Data by Axios
      let url = this.API_URL + "/dashboards/ventasafiliado";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
          let data = response.data.data;
          this.chartAfiliadosData.anulaciones = data?.anulaciones;
          this.chartAfiliadosData.ventas = data?.ventas;
          this.chartAfiliadosData.afiliados = data?.afiliados;
          if (this.chartAfiliadosData.ventas.length > 0) {
            // Usamos el método reduce para sumar todos los elementos del array
            const suma = this.chartAfiliadosData.ventas.reduce((acumulador, valorActual) => acumulador + valorActual, 0);
            // Calculamos el promedio dividiendo la suma entre la cantidad de elementos
            const promedio = (suma / this.chartAfiliadosData.ventas.length) ?? 0;
            this.stats.clients.value = "Bs " + (promedio.toFixed(2) ?? 0) + " / Afiliado ";
          }
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getProductos: function () {
      let payload = {
        "cantidad": null,
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '2025-05-01',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '2025-05-08',
      }
      // Send Data by Axios
      let url = this.API_URL + "/dashboards/ventasproducto";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
          let data = response.data.data;
          let info = [];
          let infoBs = [];
          let totalUnidadProductos = 0;
          const productos = Object.keys(data);
          productos.forEach( producto => {
            totalUnidadProductos += data[producto]?.cantidad_total ?? 0;;
            info.push({
              name: producto,
              y: data[producto]?.cantidad_total ?? 0
            })
            infoBs.push({
              name: producto,
              y: data[producto]?.precio_total ?? 0
            })
          });
          this.chartProductosData = info;
          this.chartProductosDetailsData = infoBs;
          this.stats.cantidadProductos.value = productos.length ?? 0;
          this.stats.cantidadProductos.percentage = totalUnidadProductos;
          // Usamos el método reduce para encontrar el producto con la cantidad más alta
          const productoMasCantidad = productos.reduce((a, b) => {
              return data[a].cantidad_total > data[b].cantidad_total ? a : b;
          });

          // Hacemos lo mismo para encontrar el producto con el precio más alto
          const productoMasPrecio = productos.reduce((a, b) => {
              return data[a].precio_total > data[b].precio_total ? a : b;
          });
          this.stats.sales.value = productoMasPrecio ?? "";
          this.stats.sales.percentage = productoMasCantidad ?? "";
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getAllData: function () {
      this.getTendenciaVentas();
      this.getTopAfiliados();
      this.getProductos();
    },
    validarFiltros: function () {
      this.error = '';
      if (this.fechaInicio && this.fechaFin) {
        if (this.fechaInicio > this.fechaFin) {
          this.error = 'La fecha inicial no puede ser mayor que la fecha final\n';
        }
      }
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    }
  },
  mounted() {
    this.validateRoute();
    this.getAllData();
  },
  watch: {
    selectedPeriodo(value) {
      if (value === "hoy") {
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
      }
      if (value === "semana") {
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
        this.fechaInicio.setDate(this.fechaInicio.getDate() - 7);
      }
      if (value === "mes") {
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
        this.fechaInicio.setMonth(this.fechaInicio.getMonth() - 1);
      }
      if (value === "trimestre") {
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
        this.fechaInicio.setMonth(this.fechaInicio.getMonth() - 3);
      }
      if (value !== "periodo") {
        this.getAllData();
      }
    },
    cantidadAfiliados() {
      this.getTopAfiliados();
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  components: {
    Card,
    ChartTendencias,
    ChartAfiliados,
    ChartProductosPie,
    ChartProductosColumn,
    Datepicker,
    // GradientLineChart,
    // CategoriesCard,
    VueSelect
  },
};
</script>
<style>
.highcharts-drilldown-axis-label {
  fill: #000 !important;
  text-decoration: none !important;
}
.vs__selected {
  color: var(--vs-selected-color) !important;
}
.periodoSelect {
  .vs__selected {
    color: #FFF !important;
  }
}

.periodoSelect .vs__dropdown-toggle {
  border-color: #FFF !important;
}
.periodoSelect .vs__dropdown-toggle:hover,
.periodoSelect .vs__dropdown-toggle:active {
    border-color: #FFF !important;
}
.periodoSelect .vs__clear {
  display: none !important;
}
.error-message-dashboard {
  color: red;
  font-size: 80%;
  font-weight: finer;
}
</style>
